import { createVNode as _createVNode2 } from "vue";
import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e920ba8e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "h-nav"
};
const _hoisted_2 = {
  class: "h-logo"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "n-list"
};
const _hoisted_5 = {
  class: "n-left",
  ref: "left"
};
const _hoisted_6 = {
  class: "q-menu"
};
const _hoisted_7 = {
  class: "q-menu-inner"
};
const _hoisted_8 = ["onClick", "onMouseover"];
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.2535 4.71436L9.54643 4.00725L6.0109 7.54278L2.47537 4.00725L1.76826 4.71436L5.65732 8.60341C5.65732 8.60341 5.65735 8.60344 6.0109 8.24989L5.65732 8.60341L6.0109 8.957L10.2535 4.71436Z",
  class: "arrow-icon"
})], -1));
const _hoisted_11 = [_hoisted_10];
const _hoisted_12 = {
  class: "n-right"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "split"
}, null, -1));
import { reactive, ref, inject, watch, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import navList from './nav';
import logoImg from '@/assets/img/logo.svg';
export default {
  __name: 'pcNav',
  props: {
    logoUrl: String
  },
  setup(__props) {
    const prop = __props;
    const logo = computed(() => {
      return dropDownMenu.value ? logoImg : prop.logoUrl;
    });
    const basePath = window.appConfig.VUE_APP_PATH;
    // 弹出层form
    const showFormModal = inject('showFormModal');
    const proComponent = list => {
      return _createVNode2("div", {
        "class": "q-menu_row"
      }, [list.map(item => _createVNode2("div", {
        "class": "q-menu_row-item"
      }, [_createVNode2("div", {
        "class": "q-menu-item-head"
      }, [item.label]), _createVNode2("p", null, [item.desc]), item.child.map(link => _createVNode2("div", {
        "class": "q-menu-link",
        "onClick": () => openLink(link)
      }, [_createVNode2("img", {
        "src": link.icon
      }, null), _createVNode2("span", null, [link.label])]))]))]);
    };
    const tradeComponent = list => {
      return _createVNode2("div", {
        "class": "q-menu_col"
      }, [list.map(item => _createVNode2("div", {
        "class": "q-menu_col-item"
      }, [_createVNode2("div", {
        "class": "q-menu-item-head"
      }, [item.label]), _createVNode2("p", null, [item.desc]), _createVNode2("div", {
        "class": "q-menu_col-content"
      }, [item.child.map(link => _createVNode2("div", {
        "class": "q-menu-link",
        "onClick": () => openLink(link)
      }, [_createVNode2("img", {
        "src": link.icon
      }, null), _createVNode2("span", null, [link.label])]))])]))]);
    };
    navList[0].component = proComponent;
    navList[1].component = tradeComponent;
    const navlist = reactive(navList);
    const goPage = async url => {
      window.open(window.appConfig[url], '_blank');
    };
    const router = useRouter();
    const openLink = item => {
      if (item.url) {
        if (item.openurl) {
          window.open(item.url, '_blank');
        } else {
          router.push(item.url);
        }
        dropDownMenu.value = '';
        curent.value = null;
      }
    };
    const curent = ref(null);
    const dropDownMenu = ref('');
    // onMounted(() => {
    //   curent.value = navlist[0];
    // });
    watch(curent, (item, old) => {
      if (old && old.child) {
        old.active = false;
      }
      if (!item || !item.child) {
        return dropDownMenu.value = '';
      }
      item.active = true;
      dropDownMenu.value = _createVNode2("div", {
        "class": "q-menu-dropdown",
        "onMouseleave": () => {
          dropDownMenu.value = '';
          curent.value = null;
        }
      }, [_createVNode2("div", {
        "class": "q-menu-dropdown-mark"
      }, null), _createVNode2("div", {
        "class": "q-menu-dropdown-menu"
      }, [_createVNode2("div", {
        "class": "q-menu-dropdown-menu-content"
      }, [item.component(item.child)])])]);
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_app_list = _resolveComponent("app-list");
      const _directive_track = _resolveDirective("track");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["header", {
          head_block: !!dropDownMenu.value
        }]),
        ref: "head"
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
        to: _unref(basePath)
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: _unref(logo)
        }, null, 8, _hoisted_3)]),
        _: 1
      }, 8, ["to"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navlist, (item, idx) => {
        return _openBlock(), _createElementBlock("div", {
          class: "q-menu-item",
          key: idx
        }, [_createElementVNode("div", {
          class: _normalizeClass(["q-menu-item-link", {
            is_active: item.active
          }]),
          onClick: $event => openLink(item),
          onMouseover: $event => curent.value = item
        }, [_createTextVNode(_toDisplayString(item.label) + " ", 1), item.child ? (_openBlock(), _createElementBlock("i", _hoisted_9, _hoisted_11)) : _createCommentVNode("", true)], 42, _hoisted_8)]);
      }), 128))]), (_openBlock(), _createBlock(_resolveDynamicComponent(dropDownMenu.value)))])], 512), _createElementVNode("div", _hoisted_12, [_createVNode(_component_app_list), _createVNode(_component_router_link, {
        to: _unref(basePath),
        class: "back"
      }, {
        default: _withCtx(() => [_createTextVNode("返回官网")]),
        _: 1
      }, 8, ["to"]), _hoisted_13, _withDirectives((_openBlock(), _createElementBlock("a", {
        href: "javascript:;",
        onClick: _cache[0] || (_cache[0] = $event => goPage('loginUrl'))
      }, [_createTextVNode("登录/注册")])), [[_directive_track, {
        button_name: '登录/注册',
        click_info: '顶部导航栏_登录/注册',
        event_source: '顶部导航',
        event_source_pam: null,
        event_target: '亲笔签登录页',
        event_target_pam: null
      }]]), _withDirectives((_openBlock(), _createElementBlock("a", {
        href: "javascript:;",
        class: "n-test",
        onClick: _cache[1] || (_cache[1] = $event => _unref(showFormModal)())
      }, [_createTextVNode("免费试用")])), [[_directive_track, {
        button_name: '免费试用',
        click_info: '顶部导航栏_免费试用',
        event_source: '顶部导航',
        event_source_pam: null,
        event_target: '留资表单',
        event_target_pam: null
      }]])])])])], 2);
    };
  }
};